<template>
  <el-dialog
    title="添加服务信息"
    :visible.sync="visible"
    top="20vh"
    width="600px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="服务名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入服务名称"
            maxlength="50"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="服务描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :autosize="{ minRows: 3 }"
            placeholder="请输入服务描述"
            maxlength="100"
            show-word-limit
            resize="none"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="图片" prop="imgUploadList">
          <image-upload
            url="/api/achievement/uploadachiattach"
            accept="image/jpeg,image/png,image/bmp,image/webp"
            :file-list.sync="form.imgUploadList"
            :num-limit="1"
            :size-limit="10"
            :multiple="false"
          >
            <template>
              <el-alert
                :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                type="warning"
              >
              </el-alert>
            </template>
          </image-upload>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <template v-if="dataId">
          <el-button type="primary" @click="handlerModifyData('ruleForm')"
            >修改
          </el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dataId: {
      type: String,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        name: "",
        description: "",
        imgUploadList: [] // imgUrl 相对应
      },
      rules: {
        name: [isEmpty("请输入服务名称")],
        description: [isEmpty("请输入服务描述")],
        imgUploadList: [isEmpty("请上传图片", "change")]
      },
      isLoading: false
    };
  },
  created() {
    if (this.dataId) {
      this.loadInfo();
    }
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        imgUploadList,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgUrl = deconstruct(imgUploadList[0]);
      return {
        ...others,
        imgUrl
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // 去分号
        imgUrl,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imgUrl
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      return {
        ...others,
        ...turnFile
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("expert", "addService", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("expert", "modifyService", {
        ...params,
        id: this.dataId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      this.$api("expert", "getServiceInfo", { id: this.dataId }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
